// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React from 'react';

import {useViewAction} from '../../../state/views/hooks';
import * as RunSetActions from '../../../state/views/runSet/actions';
import {MAX_PINNED_RUNS} from '../../../util/constants';
import {useRampFlagBaselineRuns} from '../../../util/rampFeatureFlags';
import {WBTableRowWithRunSetInfo} from '../../../util/tablecols';
import {
  useCurrentRunSet,
  useCurrentRunSetRef,
} from '../RunSelectorRunSetContext';
import {isRunBaseline, isRunPinned} from '../util';
import {RowHeaderMenuOption} from './RowHeaderMenuOption';

type GetBaselineLabelOpts = {
  isAnyRunBaseline: boolean;
  isRunBaseline: boolean;
};
function getBaselineLabel({
  isAnyRunBaseline,
  isRunBaseline,
}: GetBaselineLabelOpts): string {
  if (isRunBaseline) {
    return 'Remove baseline';
  } else if (isAnyRunBaseline) {
    return 'Replace baseline';
  } else {
    return 'Set baseline';
  }
}

type RunPinningAndBaselineMenuOptions = {
  row: WBTableRowWithRunSetInfo;
};

export function RunPinningAndBaselineMenuOptions({
  row,
}: RunPinningAndBaselineMenuOptions) {
  const isBaselineEnabled = useRampFlagBaselineRuns();
  const runSet = useCurrentRunSet();
  const runSetRef = useCurrentRunSetRef();
  const pinnedRunIds = runSet.pinnedRunIds || [];

  const pinned = isRunPinned(pinnedRunIds, row);
  const baseline = isRunBaseline(runSet.baselineRunId, row);
  const isAnyRunBaseline = Boolean(runSet.baselineRunId);
  const setPinnedRun = useViewAction(runSetRef, RunSetActions.setPinnedRun);
  const setBaselineRun = useViewAction(runSetRef, RunSetActions.setBaselineRun);

  const canPinRun = pinnedRunIds.length < MAX_PINNED_RUNS;

  const onPinClick = () => {
    setPinnedRun(row, !pinned);
  };
  const onBaselineClick = () => {
    setBaselineRun(baseline ? null : row);
  };

  const baselineLabel = getBaselineLabel({
    isAnyRunBaseline,
    isRunBaseline: baseline,
  });

  return (
    <>
      <RowHeaderMenuOption
        icon={<Icon name="pin" />}
        label={pinned ? 'Unpin run' : 'Pin run'}
        onSelect={onPinClick}
        disabled={!canPinRun && !pinned}
      />
      {isBaselineEnabled && (
        <RowHeaderMenuOption
          icon={<Icon name="baseline-pennant" />}
          label={baselineLabel}
          onSelect={onBaselineClick}
        />
      )}
    </>
  );
}
